import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { matchPath } from 'react-router'
import AlertCompanyHasNoOffers from '../AlertCompanyHasNoOffers'
import { ls } from 'utils/my-localstorage'
import { PersonCategories, Roles } from 'utils/consts/userRoles'
import { getPersonCategory } from 'utils/company'
import { CAPTURED_WINES_PATH } from 'utils/consts/path'
import { useAppSelector } from 'store/hooks'
import { getCompanyAccessToSellWine } from 'store/me'

const VISIBLE_ON_ROUTES = [
  `${CAPTURED_WINES_PATH}/all`,
  `${CAPTURED_WINES_PATH}/shortlist`,
]

const NoOfferAlert = () => {
  const [isRouteOk, setIsRouteOk] = useState(false)
  const companyHasAccessToSellWine = useAppSelector(getCompanyAccessToSellWine)

  const location = useLocation()
  const showVerificationAlert = !companyHasAccessToSellWine

  useEffect(() => {
    const routeMath = VISIBLE_ON_ROUTES.some(route =>
      matchPath(location.pathname, route)
    )
    setIsRouteOk(routeMath)
  }, [location.pathname])

  const role = ls.getItem('wwl-role_code') || Roles.PERSON
  const category = getPersonCategory()
  const isCompany =
    role === Roles.PERSON && category !== PersonCategories.PERSON
  const isProducer = category == PersonCategories.PRODUCER

  if (!isRouteOk || !isCompany || !isProducer) return null

  return (showVerificationAlert && <AlertCompanyHasNoOffers />) || null
}

export default NoOfferAlert
